import { Serializer, UISerializableDepositRecord } from '@drift/common';
import { getRewardHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useRewardsHistory =
	(): HistoryTableUIProps<UISerializableDepositRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'rewards',
			Serializer.Deserialize.UIDeposit
		);

		return {
			executePageChange,
			filterFn: getRewardHistoryFilter,
			historyData,
		};
	};
